export var valuesPublicLevel = ["PublicForAll", "PublicForRegistered", "Private"];
/*

*/ 
//# sourceMappingURL=PublicLevel.js.map